import { useCallback, useRef } from "react";

export const useIntersectionObserver = <T,>(onIntersection: () => void) => {
  const observer = useRef<any>();

  const elementRef = useCallback((node: T) => {
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        onIntersection();
      }
    });

    if (node) observer.current.observe(node);
  }, []);

  return elementRef;
};
